import {
  ADD_EMPLOYEE,
  ADD_MORE_USER,
  ADD_USER,
  DELETE_EMPLOYEE,
  EDIT_EMPLOYEE_PATH,
  SAVE_ADDITIONAL_EMPLOYEE_INFO,
} from '@app/constants';

import type { FormInstance } from 'antd';
import type { NavigateFunction } from 'react-router-dom';

type AfterUserUpdateProps = {
  isEditPage?: boolean;
  submitType: string;
  navigate?: NavigateFunction;
  id: number;
  createdUserId?: number;
  alterIsEmployee?: boolean;
  form?: FormInstance;
  skipPhoneState?: () => void;
};

const getNavigationPath = (
  submitType: string,
  isEditPage: boolean,
  id: number,
  createdUserId?: number,
  alterIsEmployee?: boolean
): string => {
  if (submitType === ADD_USER) {
    if (isEditPage) {
      return `/users/edit/?id=${id}&key=1`;
    }

    if (alterIsEmployee) {
      return `/users?employeeId=${createdUserId}&showEmployeeSetupDialog=true`;
    }

    return '/users';
  }

  if (submitType === ADD_MORE_USER) {
    return '/users/add';
  }

  if (submitType === ADD_EMPLOYEE) {
    if (isEditPage) {
      return `${EDIT_EMPLOYEE_PATH}?id=${id}&key=1`;
    }
    return `/employees?employeeId=${createdUserId}&showEmployeeSetupDialog=true`;
  }

  if (submitType === SAVE_ADDITIONAL_EMPLOYEE_INFO) {
    if (isEditPage) {
      return `${EDIT_EMPLOYEE_PATH}?id=${id}&key=1`;
    }
    return '/employees';
  }

  if (submitType === DELETE_EMPLOYEE) return '/employees';

  return '';
};

export const afterUserUpdate = ({
  isEditPage = false,
  submitType,
  navigate,
  id,
  createdUserId,
  alterIsEmployee,
  form,
  skipPhoneState,
}: AfterUserUpdateProps) => {
  if (!navigate) {
    return;
  }

  const path = getNavigationPath(
    submitType,
    isEditPage,
    id,
    createdUserId,
    alterIsEmployee
  );

  if (!path) {
    return;
  }

  navigate(path);

  if (submitType === ADD_MORE_USER) {
    form?.resetFields();
    skipPhoneState?.();
  }
};
